import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const restaurant = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getRestaurants() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants`)
  },
  getRestaurantsGroupedBySite() {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/restaurants`)
  },
  getRestaurantsActiveGroupedBySite() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/restaurants`)
  },
  addRestaurant(restaurant) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${restaurant.siteId}/restaurants`, restaurant)
  },
  editRestaurant(restaurant) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${restaurant.siteId}/restaurants/${restaurant.id}`, restaurant)
  },
  getRestaurantDevices(restaurantId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants/${restaurantId}/devices`)
  },
  saveRestaurantDevices(restaurantId, devicesIds, blockAccessUponPriorRestaurantBooking) {
    const body = { restaurantId: restaurantId, devices: devicesIds, blockAccessUponPriorRestaurantBooking: blockAccessUponPriorRestaurantBooking }
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants/${restaurantId}/devices`, body)
  },
  activateRestaurant(restaurant) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${restaurant.site.id}/restaurants/${restaurant.id}/activate`)
  },
  deactivateRestaurant(restaurant, cancelFutureBookings) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${restaurant.site.id}/restaurants/${restaurant.id}/deactivate?cancelFutureBookings=${cancelFutureBookings}`, {
      ignoreGlobalCatch: true,
    })
  },
  getRestaurantIntegration(restaurantId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants/${restaurantId}/integrations`)
  },
  saveIntegration(restaurantId, integration) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants/${restaurantId}/integrations`, integration)
  },
}

export default restaurant
